import { render, staticRenderFns } from "./userCourses.vue?vue&type=template&id=01b22964&scoped=true"
import script from "./userCourses.vue?vue&type=script&lang=js"
export * from "./userCourses.vue?vue&type=script&lang=js"
import style0 from "./userCourses.vue?vue&type=style&index=0&id=01b22964&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b22964",
  null
  
)

export default component.exports